import React, { Component } from 'react';
import ReactTable from "react-table";
import { CSVLink } from "react-csv";
import 'react-table/react-table.css';

class OrderScanReport extends Component {

  constructor(props) {
    super(props);

    this.state = {
      scanData: [],
      cl_id: typeof(localStorage.getItem('headerClientId')) === 'undefined' 
               ? 0 
               : localStorage.getItem('headerClientId'),
      userToken: localStorage.getItem('userToken'),
      sortOptions: [{ id: 'OrderId', desc: true }],
      dataToDownload: []
    };

    this.loadOrderScans = this.loadOrderScans.bind(this);
    this.prepare = this.prepare.bind(this);
    this.download = this.download.bind(this);
  }

  componentDidMount() {
    this.loadOrderScans();
  }

  loadOrderScans() {
    const { cl_id, userToken } = this.state;

    const body = JSON.stringify({
      cl_id: cl_id
    });

    fetch(process.env.REACT_APP_NODE_ROOT_URL + '/reports/orderscans/' + cl_id, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'bwToken': userToken
      },
      body: body
    })
    .then(res => res.json())
    .then(scanData => this.setState({ scanData }))
    .catch(err => {
      console.error('Order scan report fetch error:', err);
    });
  }

  prepare() {
    const currentRecords = this.reactTable.getResolvedState().sortedData || [];
    let data_to_download = [];

    const columns = [
      { Header: 'OrderId', accessor: 'OrderId' },
      { Header: 'Order Number', accessor: 'OrderNumber' },
      { Header: 'Required Qty', accessor: 'RequiredQty' },
      { Header: 'Pick Qty', accessor: 'PickQty' },
      { Header: 'Pack Qty', accessor: 'PackQty' },
      { Header: 'Scan Qty', accessor: 'ScanQty' },
      { Header: 'Qty Remaining', accessor: 'QtyRemaining' },
      { Header: 'Scan Status', accessor: 'ScanStatus' }
    ];

    currentRecords.forEach(record => {
      let row = {};
      columns.forEach(col => {
        row[col.Header] = record[col.accessor];
      });
      data_to_download.push(row);
    });

    this.setState({ dataToDownload: data_to_download });
  }

  download() {
    this.prepare();
    this.csvLink.link.click();
  }

  getRowStyle(row) {
    if (!row) return {};

    if (row.ScanStatus === "Complete") return { backgroundColor: "#c8e6c9" };
    if (row.ScanStatus === "Incomplete") return { backgroundColor: "#ffcdd2" };

    return {};
  }

  render() {
    const { scanData, sortOptions } = this.state;

    return (
      <div id="main">
        <div className="page-wrapper">
          <div className="row page-titles">
            <div className="col-md-11 align-self-center">
              <h3 className="text-primary">Order Scan Log</h3>
            </div>
          </div>

          <div className="container-fluid">
            <div className="row">
              <div className="col-lg-12">

                <div className="card-body">

                  <div className="table-responsive" style={{ marginTop: "15px" }}>
                    <ReactTable
                      ref={(r) => (this.reactTable = r)}
                      data={scanData}
                      sorted={sortOptions}
                      onSortedChange={(val) => this.setState({ sortOptions: val })}
                      filterable
                      noDataText="Loading order scan report..."
                      getTrProps={(state, rowInfo) => ({
                        style: rowInfo ? this.getRowStyle(rowInfo.original) : {}
                      })}
                      columns={[
                        {
                          columns: [
                            { Header: 'OrderId', accessor: 'OrderId', width: 100 },
                            { Header: 'Order Number', accessor: 'OrderNumber', width: 140 },
                            { Header: 'Required Qty', accessor: 'RequiredQty', width: 120 },
                            { Header: 'Pick Qty', accessor: 'PickQty', width: 120 },
                            { Header: 'Pack Qty', accessor: 'PackQty', width: 120 },
                            { Header: 'Scan Qty', accessor: 'ScanQty', width: 120 },
                            { Header: 'Qty Remaining', accessor: 'QtyRemaining', width: 140 },
                            { 
                              Header: 'Scan Status', 
                              accessor: 'ScanStatus', 
                              width: 140,
                              Cell: row => (
                                <div style={{ textAlign: 'center', fontWeight: 'bold' }}>
                                  {row.value}
                                </div>
                              )
                            }
                          ]
                        }
                      ]}
                      defaultPageSize={50}
                      className="-striped -highlight"
                    />
                  </div>

                </div>

              </div>
            </div>
          </div>

        </div>
      </div>
    );
  }
}

export default OrderScanReport;
